import { AlertCircleIcon, WarningIcon } from "./DashboardIcons";

import { DashboardCard } from "./DashboardCard";
// ===== NEW FILE: Payroll errors panel (copy this whole file) =====
import { PayrollErrorsData } from "../dashboardOverview.types";

export interface PayrollErrorsCardProps {
	data: PayrollErrorsData;
	onAction?: (errorId: string) => void;
	onViewHistory?: () => void;
}

export const PayrollErrorsCard = ({ data, onAction, onViewHistory }: PayrollErrorsCardProps) => {
	if (data.errors.length === 0) {
		return null;
	}

	return (
		<DashboardCard testId="payroll-errors-card">
			<div className="cd-card__header">
				<div className="cd-card__title">
					<h2>Payroll errors</h2>
					<span className="cd-badge cd-badge--danger-filled cd-payroll-errors-count">{data.count}</span>
				</div>
				<button type="button" className="cd-link-button" onClick={onViewHistory}>
					Error history
				</button>
			</div>

			<div className="cd-payroll-errors-list">
				{data.errors.map((error) => (
					<div className="cd-payroll-error" key={error.id}>
						<div className="cd-payroll-error__head">
							<AlertCircleIcon className="cd-icon--danger" />
							<span className="cd-payroll-error__title">{error.title}</span>
							{error.tagLabel && <span className="cd-badge cd-badge--danger">{error.tagLabel}</span>}
						</div>
						<p className="cd-payroll-error__description">{error.description}</p>
						<p className="cd-payroll-error__alert">{error.alert}</p>
						<button type="button" className="cd-payroll-error__action" onClick={() => onAction?.(error.id)}>
							{error.actionLabel} &rarr;
						</button>
					</div>
				))}
			</div>
		</DashboardCard>
	);
};
